<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, 1.0.0-ALPHA.1, 1.0.0-R.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('profile.material.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>


        <v-col cols="12" sm="6" md="6"  v-if="!item['@id']">
          <v-combobox
            v-if="materialsupplySelectItems"
            v-model="item.parent"
            :items="materialsupplySelectItems"
            :error-messages="parentErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('profile.material.parent')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-if="machineSelectItems"
              v-model="item.machine"
              :items="machineSelectItems"
              :error-messages="machineErrors"
              :no-data-text="$t('global.no_result')"
              :placeholder="$t('global.no_select')"
              clearable
              multiple
              :label="$t('profile.machine.machine')"
              item-text="name"
              item-value="@id"
            />
          </v-col>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <strong class="ml-4" >{{ $t('global.archive') }}:</strong>
          <v-switch
                v-model="item.archive"
                :error-messages="archiveErrors"
              ></v-switch>
        </v-col>



      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'MaterialSupplyForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.machineGetSelectItems();
      this.materialsupplyGetSelectItems({'query'  : [{'id': 'exists[parent]', 'value': 0 }]  });
  },
  data() {
    return {
        version: null,
        machine: null,
        parent: null,
        archive: null,
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_machine ||
         this.isLoading_materialsupply
       );
    },
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialsupplySelectItems: 'selectItems',
        isLoading_materialsupply : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },


    versionErrors() {
      const errors = [];

      if (!this.$v.item.version.$dirty) return errors;

      has(this.violations, 'version') && errors.push(this.violations.version);

      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    parentErrors() {
      const errors = [];
      if (!this.$v.item.parent.$dirty) return errors;
      has(this.violations, 'parent') && errors.push(this.violations.parent);
      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    archiveErrors() {
      const errors = [];
      if (!this.$v.item.archive.$dirty) return errors;
      has(this.violations, 'archive') && errors.push(this.violations.archive);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        materialsupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      version: {
        required,
      },
      parent: {
      },
      machine: {
      },
      archive: {

      },
    }
  }
};
</script>
